import { QueryClient } from "@tanstack/react-query";

// Cached data is reused across page navigations instead of refetching from
// scratch. staleTime controls how long data is served from cache without a
// background refetch; gcTime controls how long unused cache entries are kept
// around in case the user navigates back. Mirrors
// affiliate-hub/admin-dashboard/lib/queryClient.ts.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      gcTime: 10 * 60_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

export const queryKeys = {
  organization: ["organization"] as const,
  affiliateProfile: (userId: string) => ["affiliate-profile", userId] as const,
  dashboardStats: (affiliateProgramId: string) =>
    ["dashboard-stats", affiliateProgramId] as const,
  dashboardActivity: (affiliateProgramId: string) =>
    ["dashboard-activity", affiliateProgramId] as const,
  analytics: (affiliateProgramId: string, timeRange: string) =>
    ["analytics", affiliateProgramId, timeRange] as const,
  payments: (affiliateId: string) => ["payments", affiliateId] as const,
  promoMaterials: (organizationId: string) =>
    ["promo-materials", organizationId] as const,
  affiliateActivity: (
    affiliateProgramId: string,
    kind: "clicks" | "signups" | "purchases",
    page: number
  ) => ["affiliate-activity", affiliateProgramId, kind, page] as const,
};
